export default "__VITE_ASSET__3826b988__"